import React from "react";
import { format, parseISO } from "date-fns";
import { Button } from "../../Components/ui/button";
import { SkeletonTable } from "../../Components/ui/skeleton";
import Spinner from "../../Assets/spinner";
import toast from "react-hot-toast";
import {
  useGetCustomerByIdQuery,
  useDeactivateCustomerMutation,
  useReactivateCustomerMutation,
} from "./CustomerApi";

const CustomerDetail = ({ id }) => {
  const { data, isLoading } = useGetCustomerByIdQuery(id);
  const [deactivateCustomer, { isLoading: deactivating }] =
    useDeactivateCustomerMutation();
  const [reactivateCustomer, { isLoading: reactivating }] =
    useReactivateCustomerMutation();

  const customer = data?.data;

  const handleDeactivate = async () => {
    try {
      const res = await deactivateCustomer(id).unwrap();
      if (res?.statusCode < 300) {
        toast.success("Customer deactivated", { id: "customerDeactivate" });
      }
    } catch {
      toast.error("Action failed, please try again", { id: "customerErr" });
    }
  };

  const handleReactivate = async () => {
    try {
      const res = await reactivateCustomer(id).unwrap();
      if (res?.statusCode < 300) {
        toast.success("Customer reactivated", { id: "customerReactivate" });
      }
    } catch {
      toast.error("Action failed, please try again", { id: "customerErr" });
    }
  };

  if (isLoading) return <div className='w-full max-w-[300px]'><SkeletonTable /></div>;

  return (
    <div className='w-full md:min-w-[480px]'>
      <div className='mt-2 grid md:grid-cols-3 gap-5 p-2'>
        <div>
          <p className='text-xs text-gray-400 font-medium'>First Name</p>
          <p className='text-primaryBlack font-normal text-sm'>
            {customer?.firstName || "N/A"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Last Name</p>
          <p className='text-primaryBlack font-normal text-sm'>
            {customer?.lastName || "N/A"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Email</p>
          <p className='text-primaryBlack font-normal text-sm lowercase'>
            {customer?.email || "N/A"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Phone Number</p>
          <p className='text-primaryBlack font-normal text-sm'>
            {customer?.phoneNumber || "N/A"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Gender</p>
          <p className='text-primaryBlack font-normal text-sm capitalize'>
            {customer?.gender || "N/A"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Email Verified</p>
          <p className='text-primaryBlack font-normal text-sm'>
            {customer?.emailVerified ? "Yes" : "No"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Status</p>
          <p className='text-primaryBlack font-normal text-sm'>
            {customer?.activated ? "Active" : "Inactive"}
          </p>
        </div>
        <div>
          <p className='text-xs text-gray-400 font-medium'>Registered</p>
          <p className='text-primaryBlack font-normal text-sm'>
            {customer?.createdAt
              ? format(parseISO(customer.createdAt), "LLL dd, y")
              : "N/A"}
          </p>
        </div>
      </div>

      <div className='border-t border-gray-100 mt-4 pt-4 flex justify-end'>
        {customer?.activated ? (
          <Button
            variant='failed'
            onClick={handleDeactivate}
            disabled={deactivating}
          >
            {deactivating ? <Spinner /> : "Deactivate Customer"}
          </Button>
        ) : (
          <Button
            variant='successful'
            onClick={handleReactivate}
            disabled={reactivating}
          >
            {reactivating ? <Spinner /> : "Reactivate Customer"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CustomerDetail;
